<div class="display-field-title {{titleClass}}">
  <div class="display-field-title__title">
    <div class="display-field-title__text">
      <span>
        {{field?.title ?? 'missing title'}}
      </span>
    </div>
  </div>
</div>
